import { supabase } from '@/integrations/supabase/client';

/**
 * Registra que a proposta FOI ENVIADA (WhatsApp enviado ou link copiado pelo fornecedor): `events.proposal_sent_at`, só na primeira vez.
 * É o que separa "proposta enviada" de "proposta criada" no funil de vendas. Complemento: se a coluna ainda não existe ou a gravação
 * falha, o envio da proposta segue normalmente.
 */
export async function markProposalSent(eventId: string | null | undefined): Promise<void> {
  if (!eventId || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(eventId)) return;
  try {
    await (supabase as any).from('events').update({ proposal_sent_at: new Date().toISOString() }).eq('id', eventId).is('proposal_sent_at', null);
  } catch {
    /* registro nunca atrapalha o envio */
  }
}
